(function () {
  'use strict';

  // Vérification de la configuration
  if (!window.TalikaConfig) {
    console.error('❌ TalikaConfig non trouvé');
    window.TalikaConfig = { 
      products: {}, 
      money_format: '€ {amount}', 
      currency: 'EUR' 
    };
  }

  if (!window.TalikaConfig.products || typeof window.TalikaConfig.products !== 'object') {
    window.TalikaConfig.products = {};
  }

  const { products, money_format, currency = 'EUR' } = window.TalikaConfig;
  const HIDDEN_PRODUCTS = [];

  const filterHiddenProducts = products => products.filter(product => !HIDDEN_PRODUCTS.includes(product));

  // ✅ Nouvelle fonction: Sauvegarder directement dans Shopify customer metadata
  async function saveDiagnosticToShopifyCustomer(answers, recommendations) {
    try {
      // Préparer les métadonnées du diagnostic
      const diagnosticData = {
        diagnosis_age: answers.age || '',
        diagnosis_skin_type: answers.skinType || '',
        diagnosis_concerns: Array.isArray(answers.concerns) ? answers.concerns.join(', ') : '',
        diagnosis_morning_routine: recommendations.morning.join(', ') || '',
        diagnosis_evening_routine: recommendations.evening.join(', ') || '',
        diagnosis_weekly_routine: recommendations.weekly.join(', ') || '',
        diagnosis_targeted_routine: recommendations.targeted.join(', ') || '',
        diagnosis_date: new Date().toISOString(),
        diagnosis_completed: true
      };

      console.log('✅ Données du diagnostic à sauvegarder:', diagnosticData);

      // Envoyer les métadonnées à une fonction serveur Shopify
      // Cette fonction devrait faire un fetch vers une route (cart page ou API personnalisée)
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: diagnosticData  // Shopify stocke les attributs du cart
        })
      });

      if (!response.ok) {
        console.warn('⚠️ Erreur lors de la sauvegarde des métadonnées');
        return false;
      }

      console.log('✅ Métadonnées du diagnostic sauvegardées dans Shopify');
      return true;

    } catch (error) {
      console.error('❌ Erreur saveDiagnosticToShopifyCustomer:', error);
      return false;
    }
  }

  // Ajout d'un produit au panier
  async function addToCartShopify(productHandle) {
    const productData = products[productHandle];
    if (!productData) throw new Error(`Produit ${productHandle} non trouvé`);
    if (!productData.variants?.[0]?.available) throw new Error('Produit non disponible');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: productData.variants[0].id,
        quantity: 1,
        properties: {
          '_diagnostic': 'talika-skincare',
          '_source': 'diagnostic-tool',
        },
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = `Erreur HTTP: ${response.status}`;
      try {
        const errorData = JSON.parse(errorText);
        errorMessage = errorData.message || errorData.description || errorMessage;
      } catch {}
      throw new Error(errorMessage);
    }

    if (response.headers.get('content-type')?.includes('application/json')) {
      await response.json();
    }

    // Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_to_cart', {
        currency,
        value: productData.variants[0].price / 100,
        items: [{
          item_id: productData.variants[0].id,
          item_name: productData.title,
          category: 'Skincare',
          quantity: 1,
          price: productData.variants[0].price / 100,
        }],
      });
    }

    return true;
  }

  // Gestion de l'ajout d'un produit individuel
  async function handleSingleProductAdd(productKey) {
    try {
      const handle = productMapping[productKey];
      if (!handle || !products[handle]) {
        throw new Error(`Produit ${productKey} non trouvé`);
      }

      showNotification('Ajout au panier en cours...', 'info');
      await addToCartShopify(handle);
      showNotification(`✅ ${products[handle].title} ajouté au panier !`, 'success');
      await updateCartCount();
    } catch (error) {
      console.error('Erreur ajout produit:', error);
      showNotification(`❌ ${error.message}`, 'error');
    }
  }

  // Affichage des notifications
  function showNotification(message, type = 'info') {
    const existing = document.querySelector('.diagnostic-notification');
    if (existing) {
      existing.classList.remove('show');
      setTimeout(() => existing.remove(), 300);
    }

    const notification = document.createElement('div');
    notification.className = `diagnostic-notification ${type}`;
    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 8px;">
        <span>${message}</span>
        <button style="background: none; border: none; color: inherit; font-size: 18px; cursor: pointer;">×</button>
      </div>
    `;
    notification.querySelector('button').addEventListener('click', () => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    });

    document.body.appendChild(notification);
    setTimeout(() => notification.classList.add('show'), 100);

    if (type !== 'error') {
      setTimeout(() => {
        if (notification.classList.contains('show')) {
          notification.classList.remove('show');
          setTimeout(() => notification.remove(), 400);
        }
      }, 4000);
    }
  }

  // Ajout d'une routine au panier
  async function addRoutineToCart(productKeys) {
    try {
      showNotification('Ajout de la routine en cours...', 'info');
      let successCount = 0, errorCount = 0;

      for (const productKey of productKeys) {
        try {
          if (await addToCartShopify(productMapping[productKey])) successCount++;
        } catch {
          errorCount++;
        }
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      const message = successCount > 0 && errorCount === 0
        ? `✅ ${successCount} produit(s) ajouté(s) au panier !`
        : successCount > 0
          ? `✅ ${successCount} produit(s) ajoutés, ${errorCount} échec(s)`
          : `❌ Impossible d'ajouter les produits`;
      showNotification(message, errorCount === 0 ? 'success' : errorCount > 0 && successCount > 0 ? 'warning' : 'error');

      await updateCartCount();
    } catch (error) {
      console.error('Erreur ajout routine:', error);
      showNotification('Erreur lors de l\'ajout de la routine', 'error');
    }
  }

  // Ajout de la routine complète
  async function addCompleteRoutine(recommendations) {
    try {
      const uniqueProducts = [...new Set([
        ...recommendations.morning,
        ...recommendations.evening,
        ...recommendations.weekly,
        ...recommendations.targeted,
      ])];

      if (!uniqueProducts.length) {
        showNotification('❌ Aucun produit à ajouter', 'error');
        return;
      }

      showNotification(`Ajout de ${uniqueProducts.length} produits uniques...`, 'info');
      let successCount = 0, errorCount = 0;

      for (const productKey of uniqueProducts) {
        try {
          if (await addToCartShopify(productMapping[productKey])) successCount++;
        } catch {
          errorCount++;
        }
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      const message = successCount > 0 && errorCount === 0
        ? `✅ Routine complète ajoutée ! ${successCount} produits`
        : successCount > 0
          ? `✅ ${successCount} produits ajoutés, ${errorCount} échec(s)`
          : `❌ Impossible d'ajouter la routine`;
      showNotification(message, errorCount === 0 ? 'success' : errorCount > 0 && successCount > 0 ? 'warning' : 'error');

      await updateCartCount();
    } catch (error) {
      console.error('Erreur ajout routine complète:', error);
      showNotification('Erreur lors de l\'ajout de la routine complète', 'error');
    }
  }

  // Mise à jour du compteur panier
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      
      const cart = await response.json();
      if (!cart || cart.item_count === undefined) return;
      
      const selectors = [
        '.cart-count', '[data-cart-count]', '.cart-counter',
        '.cart-item-count', '#cart-count', '.header__cart-count', '.cart__count',
      ];

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        if (!elements || elements.length === 0) return;
        
        elements.forEach(el => {
          if (!el || !el.parentNode) return;
          try {
            el.textContent = cart.item_count;
            el.style.transition = 'opacity 0.3s';
            el.style.opacity = '0';
            const elementRef = el;
            setTimeout(() => {
              if (elementRef && elementRef.parentNode) {
                elementRef.style.opacity = '1';
              }
            }, 100);
          } catch (e) {
            console.warn('Erreur update cart element:', e);
          }
        });
      });

      const mainCounter = document.querySelector('.cart-count, [data-cart-count]');
      if (mainCounter && mainCounter.parentNode) {
        mainCounter.style.transition = 'transform 0.2s';
        mainCounter.style.transform = 'scale(1.2)';
        setTimeout(() => {
          if (mainCounter && mainCounter.parentNode) {
            mainCounter.style.transform = 'scale(1)';
          }
        }, 200);
      }
    } catch (error) {
      console.warn('Impossible de mettre à jour le compteur panier:', error);
    }
  }

  // Mapping des produits
  const productMapping = {
    cleanser: 'mousse-nettoyante-hydratante-skintellige',
    eauMicellaire: 'eau-micellaire-hydratante',
    serumHydra: 'serum-hydra',
    serumAntiAge: 'serum-anti-age',
    serumPurifiant: 'serum-purifiant-skintelligence',
    glowtion: 'glowtion',
    gommage: 'gommage-doux-hydratant',
    dayCremeLight: 'creme-legere-hydra',
    dayCremeRich: 'creme-riche-hydra',
    dayCremeAntiAgeDry: 'creme-de-jour-regenerante-anti-age',
    nightCremeAntiAgeDry: 'creme-de-nuit-regenerante-anti-age',
    dayCremeAntiAgeOily: 'gel-creme-anti-age-jour',
    nightCremeAntiAgeOily: 'gel-creme-anti-age-nuit',
    gelCremePurifiant: 'gel-creme-purifiant',
    maskHydrating: 'bio-enzymes-mask-hydratant',
    maskAntiAge: 'bio-enzymes-mask-anti-age',
    maskPurifying: 'bio-enzymes-mask-purifiant',
    maskBrightening: 'bio-enzymes-mask-eclaircissant',
    maskSoothing: 'bio-enzymes-mask-cica-repair-apaisant',
    freeSkin: 'free-skin',
    bubbleMask: 'bubble-mask-bio-detox',
    timeControl: 'time-control-7-plus',
  };

  // Récupération des données produit Shopify
  function getShopifyProduct(productKey) {
    const handle = productMapping[productKey];
    const shopifyProduct = products[handle];
    if (!shopifyProduct) return null;

    return {
      handle,
      name: shopifyProduct.title,
      price: shopifyProduct.price_formatted,
      image: shopifyProduct.featured_image || '',
      url: shopifyProduct.url,
      available: shopifyProduct.available,
      description: shopifyProduct.description || '',
      shopifyData: shopifyProduct,
    };
  }

  // Validation des produits
  function validateProducts() {
    const totalActiveProducts = Object.keys(productMapping).length - HIDDEN_PRODUCTS.length;
    let foundCount = 0, missingProducts = [], invalidVariants = [];

    for (const [key, handle] of Object.entries(productMapping)) {
      if (HIDDEN_PRODUCTS.includes(key)) continue;

      const product = products[handle];
      if (product) {
        foundCount++;
        if (!product.variants?.[0]?.id) {
          invalidVariants.push({ key, handle, reason: 'Variant invalide' });
        }
      } else {
        missingProducts.push({ key, handle });
      }
    }

    console.log(`📊 Produits: ${foundCount}/${totalActiveProducts} actifs trouvés`);
    if (missingProducts.length) {
      console.warn(`⚠️ Produits manquants: ${missingProducts.map(p => `${p.key}: ${p.handle}`).join(', ')}`);
    }
    if (invalidVariants.length) {
      console.warn(`⚠️ Variants invalides: ${invalidVariants.map(v => `${v.key}: ${v.reason}`).join(', ')}`);
    }
    if (HIDDEN_PRODUCTS.length) {
      console.log(`⏸️ Produits masqués: ${HIDDEN_PRODUCTS.join(', ')}`);
    }

    return foundCount > 0;
  }

  // Classe principale de l'application
  class DiagnosticApp {
    constructor(containerId) {
      this.container = document.getElementById(containerId);
      if (!this.container) {
        console.error(`Container ${containerId} non trouvé`);
        return;
      }

      this.currentStep = 0;
      this.answers = {};
      this.showResults = false;
      this.storageKey = 'talika-diagnostic-progress';
      this.questions = [
        {
          id: 'age',
          title: 'Quel est votre âge ?',
          type: 'radio',
          options: [
            { value: 'under25', label: 'Moins de 25 ans' },
            { value: '25-35', label: '25-35 ans' },
            { value: '35-45', label: '35-45 ans' },
            { value: 'over45', label: 'Plus de 45 ans' },
          ],
        },
        {
          id: 'skinType',
          title: 'Comment décririez-vous votre type de peau ?',
          type: 'radio',
          options: [
            { value: 'dry', label: 'Sèche (tiraillements, inconfort)' },
            { value: 'oily', label: 'Grasse (brillances, pores dilatés)' },
            { value: 'combination', label: 'Mixte (zone T grasse, joues normales/sèches)' },
            { value: 'normal', label: 'Normale (équilibrée, confortable)' },
          ],
        },
        {
          id: 'concerns',
          title: 'Quelles sont vos préoccupations principales ? (plusieurs réponses possibles)',
          type: 'checkbox',
          options: [
            { value: 'wrinkles', label: 'Rides et signes de vieillissement' },
            { value: 'imperfections', label: 'Imperfections, boutons, acné' },
            { value: 'dehydration', label: 'Déshydratation, manque d\'éclat' },
            { value: 'sensitivity', label: 'Sensibilité, rougeurs, irritations' },
            { value: 'spots', label: 'Taches pigmentaires, teint inégal' },
          ],
        },
      ];

      this.productDatabase = {
        cleanser: { name: 'Mousse Nettoyante Hydratante Skintelligence', description: 'Mousse nettoyante hydratante pour tous types de peau' },
        eauMicellaire: { name: 'Eau Micellaire Hydratante Skintelligence', description: 'Eau micellaire démaquillante et nettoyante' },
        serumHydra: { name: 'Serum Hydra Skintelligence', description: 'Sérum ultra-hydratant à l\'acide hyaluronique' },
        serumAntiAge: { name: 'Serum Anti-Age Skintelligence', description: 'Sérum anti-âge concentré aux peptides' },
        serumPurifiant: { name: 'Serum Purifiant Skintelligence', description: 'Sérum purifiant pour peaux à imperfections' },
        glowtion: { name: 'Glowtion', description: 'Lotion éclat révélatrice de luminosité' },
        gommage: { name: 'Gommage Doux Hydratant', description: 'Gommage doux exfoliant et hydratant' },
        dayCremeLight: { name: 'Crème Légère Hydra Skintelligence', description: 'Crème hydratante légère jour' },
        dayCremeRich: { name: 'Crème Riche Hydra Skintelligence', description: 'Crème hydratante riche jour et nuit' },
        dayCremeAntiAgeDry: { name: 'Crème de Jour Régénérante Anti-Age', description: 'Crème de jour anti-âge pour peaux sèches' },
        nightCremeAntiAgeDry: { name: 'Crème de Nuit Régénérante Anti-Age', description: 'Crème de nuit anti-âge pour peaux sèches' },
        dayCremeAntiAgeOily: { name: 'Gel-Crème Anti-Age Jour', description: 'Gel-crème de jour anti-âge pour peaux grasses et mixtes' },
        nightCremeAntiAgeOily: { name: 'Gel-Crème Anti-Age Nuit', description: 'Gel-crème de nuit anti-âge pour peaux grasses et mixtes' },
        gelCremePurifiant: { name: 'Gel-Crème Purifiant', description: 'Gel-crème purifiant pour peaux mixtes à grasses' },
        maskHydrating: { name: 'Bio Enzymes Mask Hydratant', description: 'Masque biocellulose ultra-hydratant' },
        maskAntiAge: { name: 'Bio Enzymes Mask Anti-Age', description: 'Masque biocellulose anti-âge au collagène' },
        maskPurifying: { name: 'Bio Enzymes Mask Purifiant', description: 'Masque biocellulose purifiant aux acides de fruits' },
        maskBrightening: { name: 'Bio Enzymes Mask Éclaircissant', description: 'Masque biocellulose éclat anti-taches à la vitamine C' },
        maskSoothing: { name: 'Bio Enzymes Mask Cica Repair Apaisant', description: 'Masque apaisant réparateur à la Centella Asiatica' },
        freeSkin: { name: 'Free Skin Light Therapy Device', description: 'Appareil de luminothérapie anti-imperfections' },
        bubbleMask: { name: 'Bubble Mask Bio-Detox', description: 'Masque moussant détoxifiant au charbon' },
        timeControl: { name: 'Time Control 7+ Multi-Correction', description: 'Soin anti-âge ciblé multi-correction intensif' },
      };

      this.init();
    }

    init() {
      if (!validateProducts()) {
        this.container.innerHTML = `
          <div style="text-align: center; padding: 40px; color: #dc2626;">
            <h3>⚠️ Configuration incomplète</h3>
            <p>Certains produits sont manquants dans la collection Shopify.</p>
          </div>
        `;
        return;
      }

      this.loadProgress();
      this.render();
    }

    saveProgress() {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify({
          currentStep: this.currentStep,
          answers: this.answers,
          showResults: this.showResults,
          timestamp: Date.now(),
        }));
      } catch (error) {
        console.warn('Impossible de sauvegarder le progrès:', error);
      }
    }

    loadProgress() {
      try {
        const saved = sessionStorage.getItem(this.storageKey);
        if (!saved) return;

        const { currentStep, answers, showResults, timestamp } = JSON.parse(saved);
        const maxAge = 2 * 60 * 60 * 1000;
        if (Date.now() - timestamp > maxAge) {
          this.clearProgress();
          return;
        }

        this.currentStep = currentStep || 0;
        this.answers = answers || {};
        this.showResults = showResults || false;
      } catch (error) {
        console.warn('Impossible de charger la session:', error);
        this.clearProgress();
      }
    }

    clearProgress() {
      try {
        sessionStorage.removeItem(this.storageKey);
      } catch (error) {
        console.warn('Impossible de supprimer la session:', error);
      }
    }

    generateRecommendations() {
      const { skinType, concerns = [], age } = this.answers;
      const routine = this.hasAgingSigns(concerns, age)
        ? this.getRoutineWithAgingSigns(skinType, concerns.includes('imperfections'), concerns)
        : this.getRoutineWithoutAgingSigns(skinType, concerns.includes('imperfections'), concerns);

      return {
        morning: filterHiddenProducts(routine.morning),
        evening: filterHiddenProducts(routine.evening),
        weekly: filterHiddenProducts(routine.weekly),
        targeted: filterHiddenProducts(routine.targeted),
      };
    }

    hasAgingSigns(concerns, age) {
      return concerns.includes('wrinkles') || age === 'over45' || age === '35-45';
    }

    getRoutineWithAgingSigns(skinType, hasImperfections, concerns) {
      const routine = { morning: [], evening: [], weekly: [], targeted: [] };
      if (['normal', 'dry'].includes(skinType)) {
        routine.morning = ['eauMicellaire', 'glowtion', 'serumAntiAge', 'dayCremeAntiAgeDry'];
        routine.evening = ['eauMicellaire', 'glowtion', 'serumAntiAge', 'nightCremeAntiAgeDry'];
        routine.weekly = ['maskAntiAge'];
      } else if (['combination', 'oily'].includes(skinType)) {
        routine.morning = ['cleanser', 'glowtion', 'serumAntiAge', ...(hasImperfections ? ['serumPurifiant', 'dayCremeAntiAgeOily'] : ['dayCremeAntiAgeOily'])];
        routine.evening = ['cleanser', 'glowtion', 'serumAntiAge', ...(hasImperfections ? ['serumPurifiant', 'nightCremeAntiAgeOily'] : ['nightCremeAntiAgeOily'])];
        routine.weekly = ['maskAntiAge', ...(hasImperfections ? ['maskPurifying'] : [])];
        if (hasImperfections) routine.targeted = ['freeSkin'];
      }
      this.addSupplementaryProducts(routine, concerns);
      return routine;
    }

    getRoutineWithoutAgingSigns(skinType, hasImperfections, concerns) {
      const routine = { morning: [], evening: [], weekly: [], targeted: [] };
      if (skinType === 'normal') {
        routine.morning = ['eauMicellaire', 'gommage', 'serumHydra', 'dayCremeLight'];
        routine.evening = ['eauMicellaire', 'serumHydra', 'dayCremeLight'];
        routine.weekly = ['maskHydrating'];
      } else if (skinType === 'dry') {
        routine.morning = ['eauMicellaire', 'gommage', 'serumHydra', 'dayCremeRich'];
        routine.evening = ['eauMicellaire', 'serumHydra', 'dayCremeRich'];
        routine.weekly = ['maskHydrating'];
      } else if (['combination', 'oily'].includes(skinType)) {
        routine.morning = ['cleanser', 'glowtion', ...(hasImperfections ? ['serumPurifiant', 'gelCremePurifiant'] : ['gelCremePurifiant'])];
        routine.evening = ['cleanser', 'glowtion', ...(hasImperfections ? ['serumPurifiant', 'gelCremePurifiant'] : ['gelCremePurifiant'])];
        routine.weekly = ['maskPurifying', ...(hasImperfections ? ['bubbleMask'] : [])];
        if (hasImperfections) routine.targeted = ['freeSkin'];
      }
      this.addSupplementaryProducts(routine, concerns);
      return routine;
    }

    addSupplementaryProducts(routine, concerns) {
      if (concerns.includes('spots')) {
        if (!routine.weekly.includes('maskBrightening')) routine.weekly.push('maskBrightening');
        if (!routine.targeted.includes('timeControl')) routine.targeted.push('timeControl');
      }
      if (concerns.includes('sensitivity')) {
        if (!routine.weekly.includes('maskSoothing')) routine.weekly.push('maskSoothing');
        routine.weekly = routine.weekly.filter(p => p !== 'bubbleMask');
      }
      if (concerns.includes('dehydration') && !routine.weekly.includes('maskHydrating')) {
        routine.weekly.push('maskHydrating');
      }
    }

    handleAnswer(questionId, value, isCheckbox) {
      if (isCheckbox) {
        const current = this.answers[questionId] || [];
        this.answers[questionId] = current.includes(value)
          ? current.filter(v => v !== value)
          : [...current, value];
      } else {
        this.answers[questionId] = value;
      }
      this.saveProgress();
      this.render();
    }

    nextStep() {
      if (this.currentStep < this.questions.length - 1) {
        this.currentStep++;
      } else {
        this.showResults = true;
      }
      this.saveProgress();
      this.render();
    }

    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.saveProgress();
        this.render();
      }
    }

    restart() {
      this.currentStep = 0;
      this.answers = {};
      this.showResults = false;
      this.clearProgress();
      this.render();
      showNotification('🔄 Diagnostic redémarré', 'info');
    }

    createProductCard(productKey, section, index) {
      const productInfo = this.productDatabase[productKey];
      const shopifyProduct = getShopifyProduct(productKey);
      if (!shopifyProduct) {
        return `<div class="product-error">❌ Produit ${productKey} non disponible<br><small>Handle: ${productMapping[productKey] || 'inconnu'}</small></div>`;
      }

      const imageDisplay = shopifyProduct.image && (shopifyProduct.image.startsWith('http') || shopifyProduct.image.startsWith('//'))
        ? `<img src="${shopifyProduct.image.startsWith('//') ? 'https:' + shopifyProduct.image : shopifyProduct.image}" alt="${shopifyProduct.name}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;" onerror="this.style.display='none';">`
        : `<div style="display: flex; align-items: center; justify-content: center; font-size: 24px; color: #66a8bc;">📦</div>`;

      return `
        <div class="product-card" style="background: linear-gradient(to bottom right, white, #f0f9ff); border: 2px solid #66a8bc; border-radius: 12px; padding: 16px; margin-bottom: 16px; box-shadow: 0 4px 8px rgba(102,168,188,0.1);">
          <div style="display: flex; gap: 12px; margin-bottom: 12px;">
            <div style="width: 64px; height: 64px; background: #66a8bc; color: white; border-radius: 8px; overflow: hidden;">${imageDisplay}</div>
            <div style="flex: 1;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                <h4 style="font-weight: 600; color: #1f2937; font-size: 14px; margin: 0;">${shopifyProduct.name}</h4>
                <span style="color: #66a8bc; font-weight: bold; font-size: 14px;">${shopifyProduct.price}</span>
              </div>
              <p style="color: #6b7280; font-size: 12px; margin: 4px 0;">${productInfo.description}</p>
              ${!shopifyProduct.available ? '<p style="color: #dc2626; font-size: 11px; font-weight: 500;">⚠️ Temporairement indisponible</p>' : ''}
            </div>
          </div>
          <div style="display: flex; gap: 8px;">
            <button onclick="handleSingleProductAdd('${productKey}')" style="background: ${shopifyProduct.available ? '#66a8bc' : '#9ca3af'}; color: white; border: none; padding: 8px 12px; border-radius: 8px; font-size: 12px; font-weight: 500; cursor: ${shopifyProduct.available ? 'pointer' : 'not-allowed'}; flex: 1; transition: opacity 0.2s;" ${!shopifyProduct.available ? 'disabled' : ''} onmouseover="if(${shopifyProduct.available}) this.style.opacity='0.9'" onmouseout="if(${shopifyProduct.available}) this.style.opacity='1'">${shopifyProduct.available ? '🛒 Ajouter au panier' : '😔 Épuisé'}</button>
            <a href="${shopifyProduct.url}" target="_blank" style="background: #f3f4f6; color: #374151; padding: 8px 12px; border-radius: 8px; font-size: 12px; text-decoration: none; border: 1px solid #d1d5db;">👁️ Voir</a>
          </div>
        </div>
      `;
    }

    render() {
      this.showResults ? this.renderResults() : this.renderQuestion();
    }

    renderResults() {
      if (!this.container) {
        console.error('❌ Container diagnostic-root not found');
        return;
      }

      try {
        const recommendations = this.generateRecommendations();
        this.saveProgress();
        this.lastRecommendations = recommendations;

        // ✅ Sauvegarder directement dans Shopify
        console.log('📝 Sauvegarde du diagnostic dans Shopify...');
        saveDiagnosticToShopifyCustomer(this.answers, recommendations);

        this.container.innerHTML = `
        <div style="max-width: 1200px; margin: 0 auto; padding: 24px; background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe); min-height: 100vh;">
          <div style="background: white; border-radius: 16px; box-shadow: 0 8px 16px rgba(0,0,0,0.1); padding: 32px; border: 1px solid #e5e7eb;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 16px;">
              <h1 style="font-size: clamp(18px, 4vw, 32px); font-weight: bold; color: #1f2937; margin: 0;">Votre Routine Personnalisée</h1>
              <button onclick="window.diagnostic.restart()" style="color: #66a8bc; background: none; border: none; cursor: pointer; font-size: 14px; font-weight: 500; padding: 8px 16px; border-radius: 6px;" onmouseover="this.style.background='#f0f9ff'" onmouseout="this.style.background='none'">🔄 Refaire le diagnostic</button>
            </div>
            <div class="diagnostic-results-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 24px;">
              <div>
                <h2 style="font-size: 20px; font-weight: 600; color: #1f2937; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; justify-content: space-between;">
                  <span style="display: flex; align-items: center; gap: 8px;"><span style="font-size: 24px;">🌅</span> Routine Matin</span>
                  <button onclick="window.addRoutineToCart(['${recommendations.morning.join("','")}'])" style="background: linear-gradient(135deg, #66a8bc, #4a90a4); color: white; border: none; padding: 8px 16px; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px;" onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(102, 168, 188, 0.3)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none'">🛒 Ajouter routine matin</button>
                </h2>
                ${recommendations.morning.map((productKey, index) => this.createProductCard(productKey, 'morning', index)).join('')}
              </div>
              <div>
                <h2 style="font-size: 20px; font-weight: 600; color: #1f2937; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; justify-content: space-between;">
                  <span style="display: flex; align-items: center; gap: 8px;"><span style="font-size: 24px;">🌙</span> Routine Soir</span>
                  <button onclick="window.addRoutineToCart(['${recommendations.evening.join("','")}'])" style="background: linear-gradient(135deg, #66a8bc, #4a90a4); color: white; border: none; padding: 8px 16px; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px;" onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(102, 168, 188, 0.3)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none'">🛒 Ajouter routine soir</button>
                </h2>
                ${recommendations.evening.map((productKey, index) => this.createProductCard(productKey, 'evening', index)).join('')}
              </div>
            </div>
            ${recommendations.weekly.length ? `
              <div style="margin-bottom: 24px;">
                <h2 style="font-size: 20px; font-weight: 600; color: #1f2937; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; justify-content: space-between;">
                  <span style="display: flex; align-items: center; gap: 8px;"><span style="font-size: 24px;">📅</span> Soins Hebdomadaires</span>
                  <button onclick="window.addRoutineToCart(['${recommendations.weekly.join("','")}'])" style="background: linear-gradient(135deg, #66a8bc, #4a90a4); color: white; border: none; padding: 8px 16px; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px;" onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(102, 168, 188, 0.3)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none'">🛒 Ajouter soins hebdo</button>
                </h2>
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px;">
                  ${recommendations.weekly.map((productKey, index) => this.createProductCard(productKey, 'weekly', index)).join('')}
                </div>
              </div>
            ` : ''}
            ${recommendations.targeted.length ? `
              <div style="margin-bottom: 24px;">
                <h2 style="font-size: 20px; font-weight: 600; color: #1f2937; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; justify-content: space-between;">
                  <span style="display: flex; align-items: center; gap: 8px;"><span style="font-size: 24px;">🎯</span> Soins Ciblés Intensifs</span>
                  <button onclick="window.addRoutineToCart(['${recommendations.targeted.join("','")}'])" style="background: linear-gradient(135deg, #66a8bc, #4a90a4); color: white; border: none; padding: 8px 16px; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px;" onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(102, 168, 188, 0.3)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none'">🛒 Ajouter soins ciblés</button>
                </h2>
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 16px;">
                  ${recommendations.targeted.map((productKey, index) => this.createProductCard(productKey, 'targeted', index)).join('')}
                </div>
              </div>
            ` : ''}
            <div style="padding: 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-radius: 12px; border: 1px solid #10b981; margin: 24px 0;">
              <h3 style="font-weight: 600; color: #065f46; margin-bottom: 12px; display: flex; align-items: center; gap: 8px; font-size: 18px;"><span style="font-size: 24px;">📱</span> Recevez votre code promo par WhatsApp</h3>
              <p style="font-size: 14px; color: #065f46; margin: 0 0 16px 0;">🎁 <strong>Offre exclusive :</strong> Obtenez <strong>20€ de réduction</strong> dès 100€ de commande sur la commande de votre routine !<br>Laissez votre numéro et recevez instantanément votre code promo par WhatsApp.</p>
              <div class="klaviyo-form-Re9bCe" style="margin: 16px 0;"></div>
              <p style="font-size: 12px; color: #6b7280; margin: 8px 0 0 0;">💬 Message automatique • 🔒 Numéro sécurisé • ✨ Code valable 7 jours</p>
            </div>
            <div style="padding: 20px; background: linear-gradient(135deg, #dbeafe, #e0e7ff); border-radius: 12px; border: 1px solid #3b82f6; margin-top: 24px;">
              <h3 style="font-weight: 600; color: #1e40af; margin-bottom: 12px; display: flex; align-items: center; gap: 8px; font-size: 16px;"><span style="font-size: 20px;">✨</span> Votre routine personnalisée est prête !</h3>
              <p style="font-size: 14px; color: #1e40af; margin: 0 0 16px 0;">Découvrez les produits Talika sélectionnés spécialement pour votre type de peau et vos préoccupations.</p>
              <div style="text-align: center;">
                <button id="complete-routine-btn" style="background: linear-gradient(135deg, #3b82f6, #1d4ed8); color: white; border: none; padding: 12px 24px; border-radius: 12px; font-size: 16px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);" onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 16px rgba(59, 130, 246, 0.4)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 12px rgba(59, 130, 246, 0.3)'">🛒 Ajouter votre routine complète</button>
              </div>
            </div>
            <div style="text-align: center; margin-top: 24px; padding: 16px; background: #f9fafb; border-radius: 8px;">
              <p style="margin: 0; font-size: 14px; color: #6b7280;">💝 <strong>Diagnostic créé par l'expertise Talika</strong> - Beauté française depuis 1948</p>
            </div>
          </div>
        </div>
      `;

        setTimeout(() => {
          try {
            const completeRoutineBtn = document.getElementById('complete-routine-btn');
            if (completeRoutineBtn) {
              completeRoutineBtn.addEventListener('click', () => window.addCompleteRoutine(recommendations));
            }
          } catch (e) {
            console.warn('Erreur in setTimeout renderResults:', e);
          }
        }, 100);

      } catch (error) {
        console.error('❌ Erreur renderResults:', error);
      }
    }

    renderQuestion() {
      if (!this.container) {
        console.error('❌ Container diagnostic-root not found');
        return;
      }

      try {
        const question = this.questions[this.currentStep];
        const isLastStep = this.currentStep === this.questions.length - 1;
        const canProceed = this.answers[question.id] && (question.type !== 'checkbox' || this.answers[question.id].length > 0);

        this.container.innerHTML = `
        <div style="max-width: 600px; margin: 0 auto; padding: 24px; background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe); min-height: 100vh;">
          <div style="background: white; border-radius: 16px; box-shadow: 0 8px 16px rgba(0,0,0,0.1); padding: 32px; border: 1px solid #e5e7eb;">
            <div style="margin-bottom: 24px; text-align: center;">
              <h1 style="font-size: clamp(20px, 4vw, 24px); font-weight: bold; color: #1f2937; margin-bottom: 8px; display: flex; align-items: center; justify-content: center; gap: 12px;">
                <img src="data:image/svg+xml,%3Csvg viewBox='0 0 100 40' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50' y='25' text-anchor='middle' font-family='Arial, sans-serif' font-size='16' font-weight='bold' fill='%2366a8bc'%3ETALIKA%3C/text%3E%3C/svg%3E" alt="Talika" style="height: 24px;">
                Diagnostic Skincare
              </h1>
              <p style="font-size: 14px; color: #6b7280; margin: 0;">Trouvez votre routine personnalisée en 3 étapes</p>
            </div>
            <div style="margin-bottom: 24px;">
              <div style="width: 100%; background: #e5e7eb; border-radius: 12px; height: 8px; overflow: hidden;">
                <div style="height: 100%; background: linear-gradient(90deg, #66a8bc, #4a90a4); border-radius: 12px; transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1); width: ${((this.currentStep + 1) / this.questions.length) * 100}%;">
                  <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3)); animation: shimmer 2s infinite;"></div>
                </div>
              </div>
              <p style="font-size: 13px; color: #6b7280; margin: 8px 0 0; text-align: center;">Étape ${this.currentStep + 1} sur ${this.questions.length}</p>
            </div>
            <h2 style="font-size: clamp(16px, 3vw, 18px); font-weight: 600; color: #1f2937; margin-bottom: 24px; text-align: center;">${question.title}</h2>
            <div style="display: flex; flex-direction: column; gap: 12px;">
              ${question.options.map(option => {
                const isSelected = question.type === 'checkbox'
                  ? (this.answers[question.id] || []).includes(option.value)
                  : this.answers[question.id] === option.value;
                return `
                  <label style="display: flex; align-items: center; padding: 16px; border: 2px solid ${isSelected ? '#66a8bc' : '#e5e7eb'}; border-radius: 12px; cursor: pointer; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); background: ${isSelected ? 'linear-gradient(135deg, #f0f9ff, #e6f3f5)' : 'white'};" onmouseover="if(!${isSelected}) { this.style.borderColor='#66a8bc'; this.style.background='#f9fafb'; this.style.transform='scale(1.01)'; }" onmouseout="if(!${isSelected}) { this.style.borderColor='#e5e7eb'; this.style.background='white'; this.style.transform='scale(1)'; }">
                    <input type="${question.type === 'checkbox' ? 'checkbox' : 'radio'}" name="${question.id}" value="${option.value}" ${isSelected ? 'checked' : ''} onchange="window.diagnostic.handleAnswer('${question.id}', '${option.value}', ${question.type === 'checkbox'})" style="margin-right: 12px; accent-color: #66a8bc; cursor: pointer;" />
                    <span style="color: #374151; font-size: 14px;">${option.label}</span>
                  </label>
                `;
              }).join('')}
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 32px;">
              <button onclick="window.diagnostic.prevStep()" ${this.currentStep === 0 ? 'disabled' : ''} style="padding: 12px 10px; color: ${this.currentStep === 0 ? '#9ca3af' : '#6b7280'}; background: none; border: none; cursor: ${this.currentStep === 0 ? 'not-allowed' : 'pointer'}; font-weight: 500; border-radius: 8px;" ${this.currentStep > 0 ? 'onmouseover="this.style.color=\'#374151\'; this.style.background=\'#f3f4f6\';" onmouseout="this.style.color=\'#6b7280\'; this.style.background=\'none\';"' : ''}>← Précédent</button>
              <button onclick="window.diagnostic.nextStep()" ${!canProceed ? 'disabled' : ''} style="padding: 12px; background: ${canProceed ? 'linear-gradient(135deg, #66a8bc, #4a90a4)' : '#d1d5db'}; color: white; border: none; border-radius: 12px; cursor: ${canProceed ? 'pointer' : 'not-allowed'}; font-weight: 600; box-shadow: ${canProceed ? '0 4px 12px rgba(102, 168, 188, 0.3)' : 'none'}; font-size: 14px;" ${canProceed ? 'onmouseover="this.style.transform=\'scale(1.05)\'; this.style.boxShadow=\'0 6px 16px rgba(102, 168, 188, 0.4)\';" onmouseout="this.style.transform=\'scale(1)\'; this.style.boxShadow=\'0 4px 12px rgba(102, 168, 188, 0.3)\';"' : ''}>${isLastStep ? 'Voir mes recommandations' : 'Suivant →'}</button>
            </div>
          </div>
        </div>
        <style>
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
          .diagnostic-notification {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: #fff;
            border-radius: 8px;
            padding: 12px 20px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.3s, transform 0.3s;
            z-index: 1000;
          }
          .diagnostic-notification.show {
            opacity: 1;
            transform: translateY(0);
          }
          .diagnostic-notification.info { border-left: 4px solid #3b82f6; }
          .diagnostic-notification.success { border-left: 4px solid #10b981; }
          .diagnostic-notification.warning { border-left: 4px solid #f59e0b; }
          .diagnostic-notification.error { border-left: 4px solid #dc2626; }
        </style>
      `;
      } catch (error) {
        console.error('❌ Erreur renderQuestion:', error);
      }
    }
  }

  // Initialisation
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('talika-diagnostic-root');
    if (container) {
      window.diagnostic = new DiagnosticApp('talika-diagnostic-root');
      Object.assign(window, { 
        addToCartShopify, 
        addRoutineToCart, 
        addCompleteRoutine, 
        handleSingleProductAdd, 
        showNotification, 
        updateCartCount 
      });
      console.log('✅ Diagnostic Talika prêt !');
    } else {
      console.error('❌ Container talika-diagnostic-root non trouvé');
    }
  });
})();